export default "__VITE_ASSET__7okA1elT__"